import { useRef, useState } from "react";
import { Upload, ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl, handleErr } from "../lib/api";
import { useBrands } from "../context/BrandContext";

export async function uploadAsset(file, { kind = "file", brandId = "" } = {}) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  if (brandId) fd.append("brandId", brandId);
  const { data } = await api.post("/assets", fd);
  return data;
}

export const LogoUploader = ({ compact }) => {
  const { active, reload } = useBrands();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  if (!active) return null;
  const onFile = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      await uploadAsset(f, { kind: "logo", brandId: active.brandId });
      await reload();
      toast.success("Brand logo saved");
    } catch (e) { handleErr(e); } finally { setBusy(false); }
  };
  return (
    <div className={`flex items-center gap-3 ${compact ? "" : "card-n p-4"}`} data-testid="logo-uploader">
      <div className="w-14 h-14 rounded-lg bg-slate-900 border border-slate-800 grid place-items-center overflow-hidden shrink-0">
        {active.logoAssetId ? <img data-testid="brand-logo-preview" src={fileUrl("asset", active.logoAssetId)} alt="logo" className="w-full h-full object-contain" /> : <ImagePlus size={20} className="text-slate-600" />}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium truncate">{active.businessName} logo</p>
        <p className="text-xs text-slate-500">{active.logoAssetId ? "Used in AI images and documents" : "Upload once, reuse in every creative"}</p>
      </div>
      <button data-testid="logo-upload-btn" disabled={busy} onClick={() => ref.current?.click()} className="ml-auto shrink-0 inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-slate-700 hover:border-orange-500 hover:text-orange-400 transition-colors">
        <Upload size={13} /> {busy ? "Uploading..." : active.logoAssetId ? "Replace" : "Upload logo"}
      </button>
      <input ref={ref} data-testid="logo-file-input" type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => { onFile(e.target.files[0]); e.target.value = ""; }} />
    </div>
  );
};
